<template>
  <app-header :isMenuOpen="isMenuOpen" v-on:toggle="toggleMenu" />
  <div class="modal-mask" v-if="isMenuOpen" @click="toggleMenu">
    <div class="modal-wrapper">
      <nav-link-menu :isHealth="isHealth" class="nav-menu-mobile" />
    </div>
  </div>
  <div class="section">
    <nav-link-menu :isHealth="isHealth" class="nav-menu" />
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader'
import NavLinkMenu from '../components/common/NavLinkMenu'
import chatWsService, { initChatWebSocket, closeChatWebSocket } from '@/services/chatWebSocketService'

export default {
  components: {
    NavLinkMenu,
    AppHeader,
  },
  data() {
    return {
      isMenuOpen: false,
    }
  },
  props: {
    isHealth: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    onChatWsMessage(event) {
      if (!event.data) return
      try {
        const parsed = JSON.parse(event.data)
        if (parsed.type === 'new_message_added' && this.$route.name !== 'chats') {
          this.$store.dispatch('FETCH_CHAT_UNREAD_STATUS')
        }
      } catch (e) {
        // ignore parse errors
      }
    },
  },
  mounted() {
    initChatWebSocket()
    this.$store.dispatch('FETCH_CHAT_UNREAD_STATUS')
    chatWsService.ws?.addEventListener('message', this.onChatWsMessage)
  },
  unmounted() {
    chatWsService.ws?.removeEventListener('message', this.onChatWsMessage)
    closeChatWebSocket()
  },
}
</script>
<style scoped lang="scss">
.section {
  display: flex;
  height: calc(100vh - 64px);
}

.nav-menu {
  @media only screen and (max-width: $tablet-size) {
    display: none;
  }
}

.nav-menu-mobile {
  display: none;
  @media only screen and (max-width: $tablet-size) {
    display: block;
  }
}

.main {
  flex: 4;
  background-color: #f1f1f1;
  margin: auto;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  width: 100%;
  height: 100%;
  background-color: rgba(21, 46, 57, 0.32);
  transition: opacity 0.3s ease;
  display: none;

  @media only screen and (max-width: $tablet-size) {
    display: block;
  }
}

.modal-wrapper {
  display: flex;
}
</style>
